import { isNumeric } from 'utils/helperMethods';
import { validators } from '../../utils/validators';

const validate = values => {
    const { REQUIRED, EMAIL, MAX_LENGTH } = validators;
    const errors = {};

    if (REQUIRED(values.terminalName)) {
        errors.terminalName = 'Please enter Terminal Name';
    } else {
        const specialCharRegex = /^(?=.*[a-zA-Z])[a-zA-Z0-9 _\-!@#$%^&*(),.?":{}|<>]*$/;
        if (!specialCharRegex.test(values.terminalName)) {
            errors.terminalName =
                'Terminal Name must contain at least one alphabet and may include numbers or special characters.';
        } else {
            errors.terminalName = MAX_LENGTH(values.terminalName, 90);
        }
    }

    if (values.formType === 'UPDATE' && REQUIRED(values.email)) {
        errors.email = 'Please enter email address';
    } else if (values.email && EMAIL(values.email)) {
        errors.email = 'Please enter valid email address';
    }

    if (REQUIRED(values.paymentCategory)) {
        errors.paymentCategory = 'Please select payment mode';
    }

    if (REQUIRED(values.settlementAccountRefence)){
        errors.settlementAccountRefence = 'Please select settlement account';
    }

    if (REQUIRED(values.terminalCount)) {
        errors.terminalCount = 'Please enter Terminal count';
    } else if (Number(values.terminalCount) <= 0) {
        errors.terminalCount = 'Terminal count should be greater than zero.';
    } else if (Number(values.terminalCount) % 1 !== 0) {
        errors.terminalCount = 'Terminal count must not have a decimal value.';
    } else if (Number(values.terminalCount) > 100000) {
        errors.terminalCount = 'Terminal count should be less than 100000';
    }
    return errors;
};

export default validate;
